import { useState } from "react";

import { ModalBox } from "@shared/components";

import { PolicyForm } from "@modules/cve/components";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";

export const PolicyFormModalButton = () => {
	const [openModal, setOpenModal] = useState(false);

	return (
		<div style={{ textAlign: "right", marginBottom: "20px" }}>
			<Button color="secondary" onClick={() => setOpenModal(true)} startIcon={<AddCircleIcon />}>
				CVE Policy
			</Button>

			<PolicyFormModal open={openModal} onClose={() => setOpenModal(false)} />
		</div>
	);
};

export const PolicyFormModal = ({ viewOnly = false, open, onClose }) => {
	return (
		<Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
			<ModalBox style={{ width: "80%" }}>
				<PolicyForm viewOnly={viewOnly} handleCancel={onClose} />
			</ModalBox>
		</Modal>
	);
};
